import { useMemo } from "react";
import { useParams } from "react-router-dom";
import {
  HgProduct,
  HgProductCategory,
  HgVendor,
} from "../../../../types/taxonomy";
import { useMatchProductsById } from "../../../../legacy/hooks/useMatchProductsById";

export const useProductData = () => {
  const { productId } = useParams<{ productId: string }>();

  const { matchedProductsById, loading } = useMatchProductsById([
    Number.parseInt(productId ?? "0"),
  ]);

  const product = useMemo<HgProduct>(() => {
    if (matchedProductsById.length === 0) {
      return {
        id: 0,
        name: "unknown",
        description: "unknown",
      };
    }

    return matchedProductsById[0];
  }, [matchedProductsById]);

  const category = useMemo<HgProductCategory>(() => {
    if (!product.category) {
      return {
        id: "0",
        name: "unknown",
        nameTree: ["unknown"],
      };
    }
    return product.category;
  }, [product]);

  const vendor = useMemo<HgVendor>(() => {
    if (!product.vendor) {
      return {
        id: 0,
        name: "unknown",
        url: "unknown",
      };
    }
    return product.vendor;
  }, [product]);

  return {
    isLoading: loading,
    product,
    category,
    vendor,
  };
};
